import $api from '../services';

export default {
    list(params) {
        return $api.get('/settings', params);
    },
    get(name) {
        return $api.get(`/settings/${name}`);
    },
    update(name, value) {
        return $api.put(`/settings/${name}`, { value });
    }
};
